/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Why the received share differs from the final entitlement
 */
export enum RatchetShareDifferenceReason {
    UNITS_NOT_SHARING = 'UNITS_NOT_SHARING',
    SCALED_BACK = 'SCALED_BACK',
    SCALED_UP = 'SCALED_UP',
}
